import { suiteReturnPath } from './suiteAuthFlow';
export const cmsReturnPath = (value: unknown): string => suiteReturnPath(value, '/content');
export function cmsDestination(workspaces: { businessId: string }[], selected: string | null, requested: unknown): string {
  if (workspaces.length === 1 || workspaces.some(site => site.businessId === selected)) return cmsReturnPath(requested);
  return '/select-site';
}
